export interface JWTPayload {
  auth_embedded?: boolean;
  reference_id?: string;
  [key: string]: unknown;
}

export function decodeJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('[zh-web-sdk] Invalid JWT format');
      return null;
    }

    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch (error) {
    console.error('[zh-web-sdk] Error decoding JWT:', error);
    return null;
  }
}

